import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AppGuardService implements CanActivateChild {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }
    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const url: string = state.url;
        const isLoggedIn = this.authService.getToken();

        // Nếu chưa đăng nhập và không phải đang ở trang login
        if (!isLoggedIn && url !== '/login') {
            this.router.navigate(['/login']);
        }


        // 1. Whitelist các route đặc biệt
        const whitelist = [

            '/notfound',
            '/under-maintenance',
            '/access-denied',
            '/login',
            "/template"
        ];
        if (whitelist.includes(url)) return true;

        // 2. Check quyền
        // if (!this.authService.checkModulePermission(url)) {
        //     this.router.navigate(['/access-denied']);
        //     return false;
        // }

        return true;
    }
}
